'use client'

import { Role } from '@/lib/role'
import { useSession } from 'next-auth/react'

export type UserProfile = {
  id: string | undefined
  email: string | undefined
  firstName: string
  lastName: string
  roles: Role[]
  city: string | undefined
}

export function useUserProfile(): UserProfile | undefined {
  const session = useSession()
  const profile = session.data?.profile
  if (profile === undefined) {
    return undefined
  }
  return {
    id: profile.upn.split('@').at(0),
    email: profile.email,
    firstName: profile.firstName,
    lastName: profile.lastName,
    roles: profile.groupIds,
    city: profile.city,
  }
}
